export default function Debounce(func, wait) {
    let timeout;
    return function() {
      const functionCall = () => func.apply(this, arguments);
      clearTimeout(timeout);
      timeout = setTimeout(functionCall, wait);
    };
  }